<template>
  <InputComponent v-model.number="comp" :label="label" required :mask="mask" v-bind="$attrs" v-on="$listeners">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </InputComponent>
</template>

<script>
import { ValueComp } from '@/utils'
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'

const meta = {
  order: 1,
  label: i18n.t('unitNumber'),
}

export { meta }
export default {
  props: {
    value: [Number, String],
    pattern: String,
  },
  computed: {
    comp: ValueComp(),
    label: () => meta.label,
    mask() {
      if (!this.pattern) return { mask: Number, unmask: true, thousandsSeparator: ' ' }
      return { mask: this.pattern, unmask: true }
    },
  },
  components: {
    InputComponent,
  },
}
</script>
